import React from "react";

import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, useController } from "react-hook-form";

import {
    TimezoneTypeaheadPopupInput,
    TimezoneTypeaheadValue,
} from "../fields/timezoneTypeaheadPopupInput";

interface RHFTimezoneTypeaheadInputProps<
    TFieldValues extends FieldValues,
> extends BaseRHFWidgetProps<TFieldValues, TimezoneTypeaheadValue> {
    label?: React.ReactNode;
    disabled?: boolean;
}
export const RHFTimezoneTypeaheadPopupInput = <
    TFieldValues extends FieldValues,
>({
    name,
    control,
    label,
    disabled = false,
}: RHFTimezoneTypeaheadInputProps<TFieldValues>) => {
    const { field, fieldState } = useController({ name, control, disabled });

    return (
        <TimezoneTypeaheadPopupInput
            label={label}
            disabled={field.disabled}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            error={fieldState.error?.message}
            fieldRef={field.ref}
        />
    );
};
